import { ProductsState } from "./products-state.interface";

export function createProductsState(): ProductsState {
  return {
    loading: false,
    searchResults: null,
  };
}
